import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../../node_modules/prop-types/index.js';
import { BREAKPOINTS } from '../../spacing/index.js';
import Footer from '../Footer/index.js';
import SideNav from '../SideNav/index.js';
import UtilityHeader from '../UtilityHeader/index.js';
import { ConnectedWrapper, SideNavWrapper, MainContainer, MainContent, MainWrapper } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';
import useMedia from '../../hooks/useMedia.js';

var _excluded = ["children", "footer", "header", "isSideNavOpen", "isStatic", "sideNav"];
var Layout = function Layout(_ref) {
  var _theme$layout;
  var children = _ref.children,
    footer = _ref.footer,
    header = _ref.header,
    isSideNavOpen = _ref.isSideNavOpen,
    isStatic = _ref.isStatic,
    sideNav = _ref.sideNav,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var isGlobal = ((_theme$layout = theme.layout) === null || _theme$layout === void 0 ? void 0 : _theme$layout.cds) === true;
  var isMobile = useMedia(["(max-width: ".concat(BREAKPOINTS.DESKTOP_SM, "px)")], [true], false);

  // We want the main content area to be "collapsed" in mobile view
  var isExpanded = isMobile ? false : isSideNavOpen;
  return isGlobal ? /*#__PURE__*/React.createElement(ConnectedWrapper, {
    "data-testid": "main-wrapper-cds"
  }, /*#__PURE__*/React.createElement(SideNavWrapper, null, sideNav), /*#__PURE__*/React.createElement(MainContainer, {
    isExpanded: isExpanded,
    isStatic: isStatic
  }, header, /*#__PURE__*/React.createElement(MainContent, rest, children), footer)) : /*#__PURE__*/React.createElement(React.Fragment, null, header, /*#__PURE__*/React.createElement(MainWrapper, {
    "data-testid": "main-wrapper-can"
  }, /*#__PURE__*/React.createElement(SideNavWrapper, null, sideNav), /*#__PURE__*/React.createElement(MainContainer, {
    isExpanded: isExpanded,
    isStatic: isStatic
  }, /*#__PURE__*/React.createElement(MainContent, rest, children), footer)));
};
process.env.NODE_ENV !== "production" ? Layout.propTypes = {
  /** Main content */
  children: PropTypes.node.isRequired,
  /** Footer */
  footer: PropTypes.node,
  /** UtilityHeader */
  header: PropTypes.node,
  /** Boolean to specify whether SideNav is open or closed */
  isSideNavOpen: PropTypes.bool,
  /** Whether SideNav is static (used alongside `shouldCloseOnBlur` prop) */
  isStatic: PropTypes.bool,
  /** SideNav */
  sideNav: PropTypes.node
} : void 0;
Layout.defaultProps = {
  footer: /*#__PURE__*/React.createElement(Footer, null),
  header: /*#__PURE__*/React.createElement(UtilityHeader, null),
  isSideNavOpen: false,
  isStatic: false,
  sideNav: /*#__PURE__*/React.createElement(SideNav, null)
};
process.env.NODE_ENV !== "production" ? Layout.displayName = 'Layout' : void 0;
var Layout$1 = Layout;

export { Layout$1 as default };
